/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A header row names the series; the first column names the categories.`)
};

const es_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una fila de cabecera nombra las series; la primera columna nombra las categorías.`)
};

const de_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eine Kopfzeile benennt die Serien; die erste Spalte benennt die Kategorien.`)
};

const nl_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Een headerrij benoemt de reeksen; de eerste kolom benoemt de categorieën.`)
};

const fr_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une ligne d'en-tête nomme les séries ; la première colonne nomme les catégories.`)
};

const it_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una riga di intestazione nomina le serie; la prima colonna nomina le categorie.`)
};

const pt_br2_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha de cabeçalho nomeia as séries; a primeira coluna nomeia as categorias.`)
};

const pt_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma linha de cabeçalho nomeia as séries; a primeira coluna nomeia as categorias.`)
};

const ja_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ヘッダー行は系列名を、最初の列はカテゴリ名を指定します。`)
};

const zh_bar_ex3 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`表头行命名系列；第一列命名类别。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const bar_ex3 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.bar_ex3(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("bar_ex3", locale)
	if (locale === "en") return en_bar_ex3(inputs)
	if (locale === "es") return es_bar_ex3(inputs)
	if (locale === "de") return de_bar_ex3(inputs)
	if (locale === "nl") return nl_bar_ex3(inputs)
	if (locale === "fr") return fr_bar_ex3(inputs)
	if (locale === "it") return it_bar_ex3(inputs)
	if (locale === "pt-BR") return pt_br2_bar_ex3(inputs)
	if (locale === "pt") return pt_bar_ex3(inputs)
	if (locale === "ja") return ja_bar_ex3(inputs)
	return zh_bar_ex3(inputs)
};